/**
 * 认证API端点常量
 * 统一管理所有认证相关的API路径
 */
/**
 * 认证API端点
 */
export const AUTH_ENDPOINTS = {
    // 核心认证
    REGISTER: '/auth/register',
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    REFRESH_TOKEN: '/auth/refresh-token',
    // 用户信息
    CURRENT_USER: '/users/me',
    // 密码管理
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password',
    CHANGE_PASSWORD: '/auth/change-password',
    // 邮箱验证
    RESEND_VERIFICATION: '/auth/resend-verification',
    VERIFY_EMAIL: '/auth/verify-email',
};
//# sourceMappingURL=endpoints.js.map